import { render, staticRenderFns } from "./routerBox.vue?vue&type=template&id=00c22860&scoped=true"
import script from "./routerBox.vue?vue&type=script&lang=js"
export * from "./routerBox.vue?vue&type=script&lang=js"
import style0 from "./routerBox.vue?vue&type=style&index=0&id=00c22860&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c22860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c22860')) {
      api.createRecord('00c22860', component.options)
    } else {
      api.reload('00c22860', component.options)
    }
    module.hot.accept("./routerBox.vue?vue&type=template&id=00c22860&scoped=true", function () {
      api.rerender('00c22860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/routerBox.vue"
export default component.exports